import { gql } from "@apollo/client";

export const createSegment = gql`
  mutation CreateSegment($input: SegmentInput!) {
    createSegment(input: $input)
  }
`;

export const updateSegment = gql`
  mutation UpdateSegment($input: SegmentInput!) {
    updateSegment(input: $input) {
      id
      name
    }
  }
`;

export const deleteSegment = gql`
  mutation DeleteSegment($id: ID!) {
    deleteSegment(id: $id)
  }
`;
